import { palette } from 'charts/common';
import { Color } from 'shared/utils/colors';

/** Brand-first series colors for MUI X Charts (dashboard + detail). */
export const CHART_SERIES_PALETTE: readonly string[] = [
  Color.primaryOrange,
  palette.orange,
  Color.blue,
  palette.lightblue,
  Color.statusSuccessGreen,
  palette.green,
  palette.purple,
  palette.pink,
  palette.red,
  palette.marine,
  palette.darkblue,
  palette.yellow,
  palette.lightgreen,
  Color.disabledGray,
];
